module.exports = __webpack_public_path__ + "static/media/Frame.b6e716ff.webp";